export function videoPlayer() {
	document.querySelectorAll('.video-player').forEach((player) => {
		const video = player.querySelector('.video-player__video')
		const playButton = player.querySelector('.video-player__play')
		const progress = player.querySelector('.video-player__progress')
		const progressFill = player.querySelector('.video-player__progress-fill')

		if (!video || !playButton || !progress || !progressFill) return

		const updateProgress = () => {
			const percent = video.duration ? (video.currentTime / video.duration) * 100 : 0

			progressFill.style.width = `${percent}%`
			progress.setAttribute('aria-valuenow', Math.round(percent))
		}

		const setPlayingState = (isPlaying) => {
			player.classList.toggle('is-playing', isPlaying)
			progress.hidden = !isPlaying
		}

		playButton.addEventListener('click', (event) => {
			event.stopPropagation()
			video.play()
		})

		video.addEventListener('click', () => {
			if (!player.classList.contains('is-playing')) return

			if (video.paused) {
				video.play()
			} else {
				video.pause()
			}
		})

		progress.addEventListener('click', (event) => {
			event.stopPropagation()

			if (!video.duration) return

			const rect = progress.getBoundingClientRect()
			const percent = (event.clientX - rect.left) / rect.width

			video.currentTime = percent * video.duration
			updateProgress()
		})

		video.addEventListener('timeupdate', updateProgress)
		video.addEventListener('loadedmetadata', updateProgress)

		video.addEventListener('play', () => {
			setPlayingState(true)
		})

		video.addEventListener('pause', () => {
			if (!video.ended) {
				setPlayingState(false)
			}
		})

		video.addEventListener('ended', () => {
			setPlayingState(false)
			progressFill.style.width = '0%'
			progress.setAttribute('aria-valuenow', '0')
		})
	})
}
